import React, { useEffect, useRef, useState } from 'react';
import FlagIcon from '../../Icons/FlagIcon';
import { countrySelectorUtil } from '../../../../utils/countrySelectorUtil';
import { countryCodes } from '../../../../models/Country';
import { Country } from '../../../../models/Country';
import 'amazon-connect-streams';
import { IconButton, ListItem, Menu, MenuItem, Typography } from '@coolblue-development/freddy';

interface CountrySelectorProps {
  onCountrySelect: (country: Country) => void;
  disabled: boolean;
  channel: 'chat' | 'email';
}

const QuickRepliesCountrySelector: React.FC<CountrySelectorProps> = ({ onCountrySelect, disabled, channel }) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState<Country | null>(null);

  const handleClick = (): void => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleMenuItemClick = (country: Country): void => {
    setSelectedCountry(country);
    onCountrySelect(country);
    handleClose();
  };

  useEffect(() => {
    const defaultCountry = countrySelectorUtil(countryCodes, true);
    setSelectedCountry(defaultCountry);
    onCountrySelect(defaultCountry);
  }, [onCountrySelect]);

  return (
    <>
      <IconButton
        ref={buttonRef}
        sx={{
          height: '48px',
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          border: '1px solid #DDDDDD',
          background: open ? '#F2F7FC' : 'inherit',
          borderColor: open ? '#0090E3' : '#DDDDDD',
          borderRightColor: open ? '#0090E3' : 'transparent',
          ':hover': { borderColor: '#DDDDDD', borderRightColor: 'transparent' },
          ':disabled': { borderColor: '#DDDDDD', borderRightColor: 'transparent' }
        }}
        data-testid={`${channel}-quick-replies-country-selector-button-${selectedCountry?.country ?? ''}`}
        size="large"
        disabled={disabled}
        onClick={handleClick}
        variant="transparent"
      >
        {selectedCountry ? <FlagIcon Component={selectedCountry.icon} /> : null}
      </IconButton>
      <Menu
        sx={{
          position: 'relative',
          zIndex: 20,
          width: '175px',
          '& > div': { overflowY: 'auto' }
        }}
        data-testid={`${channel}-quick-replies-country-selector-menu`}
        referenceElement={buttonRef.current}
        open={open}
        onClose={handleClose}
        placement="top-start"
        maxHeight="300px"
      >
        {countryCodes
          .filter(country => country.label)
          .map(country => (
            <MenuItem key={country.code} onClick={() => handleMenuItemClick(country)}>
              <ListItem sx={{ display: 'flex', alignItems: 'center', gap: '8px', listStyle: 'none' }}>
                <FlagIcon Component={country.icon} />
                <Typography sx={{ '&&&': { marginBottom: '0px' } }}>{country.label}</Typography>
              </ListItem>
            </MenuItem>
          ))}
      </Menu>
    </>
  );
};

export default QuickRepliesCountrySelector;
